// import moment from 'moment';



export const getOrdersTopTableData = async (webquotecontrol) => {


    let firstTry = await APICall(10000)
    // console.log('getOrdersTopTableData first', firstTry)
    if (typeof firstTry === "object") {
        return firstTry
    } else {
        let secondTry = await APICall(10000)
        // console.log('getOrdersTopTableData second', secondTry)
        if (typeof secondTry === "object") {
            return secondTry
        } else {
            let thridTry = await APICall(10000)
            // console.log('getOrdersTopTableData third', thridTry)
            if (typeof thirdTry === "object") {
                return thridTry
            } else {
                console.warn("getOrdersTopTableData saw an api call fail 3x")
                return 'failed'
            }
        }
    }

    async function APICall(timeOutValue) {

        return new Promise(function (resolve, reject) {

            let controller = new AbortController();

            let url = "https://api.shippersedge.com/analyze/client/kissner/shipment-counts"

            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");

            var requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            let request = new Request(url, requestOptions);

            if (timeOutValue) {
                setTimeout(() => controller.abort(), timeOutValue);
            }


            fetch(request)
                .then((response) => {
                    // console.log(
                    //   "debug getOrdersTopTableData.js response",
                    //   response
                    // );
                    if (!response.ok) {
                        console.error(
                            "getOrdersTopTableData.js error",
                            response.statusText,
                            response
                        );
                        throw Error(response.statusText);
                    }
                    return response.json();
                })
                .then((response) => {
                    // console.log('getOrdersTopTableData', response)
                    resolve(response);
                })
                .catch((err) => {
                    console.error("getOrdersTopTableData API Request failed", err);
                    resolve(err);
                });
        });
    }
};

export default getOrdersTopTableData